module.exports = __webpack_public_path__ + "static/img/2.4daca30b.jpg";